export default __webpack_public_path__ + "static/media/TransferContactGray.b3e53703.svg";